<div class="product">
    <shared-product-list-item [product]="productData" [homeIndexData]="homeIndexData">
    </shared-product-list-item>
  </div>